import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ResourcesCreateControllerModule } from './controllers/ResourcesCreateController';

export const resourcesCreateView = angular
  .module('acme.view.application.resources.create', [uiRouter, 'ui.bootstrap', ResourcesCreateControllerModule])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.resources.create',
      url: '/create?type',
      views: {
        'subview-main': {
          controller: 'ResourcesCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/resources/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Resource Template',
      },
    });
  }).name;
